<script>
import {mapActions, mapState} from "pinia";
import {appStore} from "@/store/appStore";
import Dialog from "primevue/dialog";


export default {
  name: "ReportBugModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(appStore,[
      'reportBugModalState'
    ])
  },
  methods: {
    ...mapActions(appStore, [
      'toggleReportBugModal'
    ])
  }
}
</script>

<template>
  <Dialog v-model:visible="reportBugModalState"
          modal
          class="report-bug-modal"
          :header="$t('sidebar.reportBugModal.title')"
  >
    <p class="report-bug-modal__text">
      {{$t('sidebar.reportBugModal.text.p1')}}
      <a href="mailto:bugs@peoplepolitics.com">bugs@peoplepolitics.com</a>
      {{$t('sidebar.reportBugModal.text.p2')}}
    </p>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="toggleReportBugModal">
        {{$t('common.buttons.close')}}
      </button>
    </template>
  </Dialog>
</template>

<style scoped>

</style>
